import React from 'react'
import { useHistory } from 'react-router-dom'
import Google_Ico from './google.png'

function Index() {

    const HISTORY = useHistory()

    const GoogleLogin = () => {
        window.google.accounts.oauth2.initCodeClient({
            client_id: '577109105568-e65ha2mpib84tua3o06b2qrjnldosutk.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/userinfo.email',
            ux_mode: 'redirect',
            redirect_uri: "https://oauth.dice.tech",
            state: "GOOGLE_LOGIN"
          }).requestCode()
    }

    return ( 
        <div className='FadeInUp-Effect pd5 text-center' style={{
            margin: 'auto',
            backgroundColor: '#fff',
            borderRadius: '1rem',
            width: '100%',
            minWidth: '280px',
            height:'100vh',
            display:'flex',
            justifyContent:'center',
            alignItems: 'center'
        }}>
            <div>
                <img className='mb-4 m-auto' src={Google_Ico} style={{width:'100%',maxWidth: '80px'}} alt=""/>
                <h1 className='fw-bold'>Google Login</h1>
                <p style={{marginBottom: '40px'}}>You have SSO enabled for your account</p>
                <button className='btn btn-outline-dark me-2' onClick={()=>HISTORY.goBack()}>Cancel</button>
                <button className='btn btn-primary' onClick={GoogleLogin}>Sign in with Google</button>
            </div>
            
        </div>
     );
}

export default Index;